import { isNode } from 'detect-node-es';
export var env = {
    isNode: isNode,
    forceCache: false,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/use-sidecar/dist/es2015/env.js
// module id = 1190
// module chunks = 0